<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,3C14,2.45,13.55,2,13,2C13,2,3,2,3,2C2.45,2,2,2.45,2,3C2,3,2,4,2,4C2,4,14,4,14,4C14,4,14,3,14,3C14,3,14,3,14,3ZM12,0C12,0,4,0,4,0C3.45,0,3,0.45,3,1C3,1,13,1,13,1C13,0.45,12.55,0,12,0C12,0,12,0,12,0ZM15,5C15,5,1,5,1,5C0.45,5,0,5.45,0,6C0,6,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,6,16,6C16,5.45,15.55,5,15,5C15,5,15,5,15,5ZM12,11C12,11.55,11.55,12,11,12C11,12,5,12,5,12C4.45,12,4,11.55,4,11C4,11,4,9,4,9C4,9,5,9,5,9C5,9,5,11,5,11C5,11,11,11,11,11C11,11,11,9,11,9C11,9,12,9,12,9C12,9,12,11,12,11C12,11,12,11,12,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Projects',
} as DefineComponent
</script>
